"use client";

import UnlockAfterSignup from "@/components/common/unlock-after-signup";
import { useAuth } from "@/providers/auth-provider";

const PostContent = ({
	postContent,
	isPremiumPost = false,
}: {
	isPremiumPost?: boolean;
	postContent?: string;
}) => {
	const { isLoggedIn } = useAuth();

	return (
		<div className="relative">
			{isPremiumPost && !isLoggedIn ? (
				<>
					<div className="absolute z-10 h-full w-full bg-white/10 backdrop-blur-sm" />

					<UnlockAfterSignup
						title={<span>Sign Up to continue reading</span>}
						className="absolute left-1/2 top-8 z-20 w-full max-w-md -translate-x-1/2 rounded-3xl bg-white p-6 shadow-lg"
					/>

					<div
						className="media-content p-8 text-lg"
						dangerouslySetInnerHTML={{ __html: postContent?.slice(0, 1200) || "" }}
					/>
				</>
			) : (
				<div
					className="media-content text-lg"
					dangerouslySetInnerHTML={{ __html: postContent || "" }}
				/>
			)}
		</div>
	);
};

export default PostContent;
